/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Reducer for the container.
 */
import { updateState, addPropertyInItem } from '../../common/helpers';
import { NOTIFY, UPDATE_VALUE, FETCH_COMPLETE, FETCH_DATA } from './types';
import { parsePath } from '../../common/helpers';

const INITIAL_STATE = {
    formOpen: false,
    formOpenNewCustomer: false,
    isLoading: false,
    customsClearences: [],
    modalInfoState: {
        modalInfoOpen: false,
        customsClearence: {
            supplier: {},
            customer: {},
            customsHouse: {},
            type: '',
            via: '',
        },
        index: ''
    },
    modalPrefacturaState: { open: false, customClearence: {} },
    newCustomsclearece: {},
    numPages: 0,
    activePage: 0,
    preInvoiceSequence: null, //last preinvoice created
    preInvoiceCreated: false //recent preinvoice has been created
};

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case UPDATE_VALUE:
            return updateState(payload, state);
        case NOTIFY:
            return updateState(payload, state);
        case FETCH_DATA:
            return { ...state, isLoading: true };
        case FETCH_COMPLETE:
            return { ...state, ...updateState(payload, state), isLoading: false };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./containers/despachos/reducer.js